module.exports = __webpack_public_path__ + "static/media/รายงานการรับชำระหนี้.7be0a05b.xls";